import { gql } from "@apollo/client";

export const SHOP_FRAGMENT = gql`
  fragment ShopPart on Shop {
    id
    lbcId
    name
    categoryId
    categoryName
    rating
    siren
    phone
    isMobile
    slogan
    website_url
    address
    city
    postal
    lat
    lng
    membersCount
    adsCount
  }
`;

export const SHOPS = gql`
  query ShopsQuery($limit: Int!, $offset: Int!, $where: ShopsFiltersInput!) {
    shops(limit: $limit, offset: $offset, where: $where) {
      hasMore
      total
      results {
        ...ShopPart

        members {
          id
          name
          position
        }
      }
    }
  }
  ${SHOP_FRAGMENT}
`;

export const CREATE_SHOP = gql`
  mutation CreateShopMutation($input: CreateShopInput!) {
    createShop(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_SHOP = gql`
  mutation UpdateShopMutation($id: Int!, $input: UpdateShopInput!) {
    updateShop(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const SHOP = gql`
  query ShopQuery($id: Int!) {
    shop(id: $id) {
      ok
      error
      result {
        ...ShopPart

        members {
          id
          name
          position
        }
      }
    }
  }
  ${SHOP_FRAGMENT}
`;
